import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  padding: 100px 30px;

  h1 {
    text-align: center;
    margin-bottom: 50px;
  }

  @media (max-width: 600px) {
    padding: 100px 20px;
  }
`;

export const CategoriaTitulo = styled.h2`
  font-size: 1.5rem;
  margin: 50px 0 10px 0;
`;

export const ListaCanais = styled.section`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px 10px;
  list-style: none;
  padding: 0;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Channel = styled(Link)`
  display: flex;
  flex-direction: column;
  color: #fff;

  .thumb {
    width: 100%;
    aspect-ratio: 16 / 8.7;
    background: ${(props) => props.background};
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .thumb img {
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    padding: ${(props) => (props.no_padding ? "0" : "20px")};
    object-fit: contain;
  }

  .name {
    margin-top: 10px;
    font-size: 1rem;
  }
`;
